import React from "react";
import * as Yup from 'yup';
import { TipoContratto } from "../../generated"
import { Forms } from "../../common/components/CmForms";
const { Form, FormText, FormInteger, ActionBar } = Forms<TipoContratto>()

interface Props {
    customer: TipoContratto;
    onSubmit: (customer: TipoContratto) => void;
    onCancel: () => void;
}

export default class TipoContrattoForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<TipoContratto>>({
        mesiValidita: Yup
            .number()
            .moreThan(0)
            .required('Deve essere maggiore di 0'),
    })

    render() {
        const { customer } = this.props;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={customer}
                validationSchema={TipoContrattoForm.validationSchema}
            >
                <>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <FormText
                                name="descrizione"
                                label="Descrizione tipo contratto"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormInteger
                                name="mesiValidita"
                                label="Mesi Validità"
                            />
                        </div>
                    </div>
                    <ActionBar
                        onCancel={this.props.onCancel}
                    />
                </>
            </Form>
        );
    }
}
